export const validatedEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@([^\s@_]+\.)+[^\s@_]+$/;
  return emailRegex.test(email);
};
